/***************************************************
==================== JS INDEX ======================
****************************************************

****************************************************/

$(() => {
    'use strict'

})
